import { render, staticRenderFns } from "./IconCheckboxOff.vue?vue&type=template&id=d5170280&"
import script from "./IconCheckboxOff.vue?vue&type=script&lang=js&"
export * from "./IconCheckboxOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports